import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';

// TODO: Add your Meta Pixel ID here before enabling any tracking implementation.
export const META_PIXEL_ID = '';
render(<BrowserRouter data-id="element-361" data-mp="21cah8a4v6fif">
    <App data-id="element-362" data-mp="269amwjxsxg90" />
  </BrowserRouter>, document.getElementById('root'));